// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import '../web/jquery.tokeninput';

export default class TokenInput extends WebComponent {
	didMount() {
		const {
			tokenInputUrl,
			tokenInputHintText,
			tokenInputNoResultsText,
			tokenInputSearchingText,
			tokenInputPrepopulate,
		} = this.props;
		const $self = $(this.element);
		const options = {
			onAdd: function(item) {
				$self.trigger('change');
			},
			onDelete: function(item) {
				$self.trigger('change');
			},
			preventDuplicates: true,
			excludeCurrent: true,
			hintText: tokenInputHintText,
			propertyToSearch: 'title',
			onResult: function(results) {
				return results.items;
			},
			noResultsText: tokenInputNoResultsText,
			searchingText: tokenInputSearchingText,
			...(tokenInputPrepopulate !== false) ? {prePopulate: tokenInputPrepopulate} : ''
		};
		$self.tokenInput(tokenInputUrl, options);
	}
}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/TokenInput.js